<template>
    <!-- Notifications Dropdown -->
    <div class="dropdown px-sm-0">
        <div class="pr-0">
            <el-dropdown class="" trigger="click">
                <span class="el-dropdown-link">
                    <div class="d-flex align-items-center">
                        <div class="avatar-wrapper position-relative" @click="getNotifications">
                            <div class="text-center text-white notification-count" v-if="note.unread_count > 0">{{note.unread_count | messageCount}}</div>
                            <el-tooltip class="item" effect="dark" content="Notifications" placement="bottom">
                                <i class="icon-bell-outline" style="color:#00448b"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </span>
                <el-dropdown-menu slot="dropdown" class="searchBoxNavbar pt-0 pb-0">
                    <div class="d-flex justify-content-between px-1 py-3 w-325px w-md-375px">
                        <div class="lh-24px fs-15 ml-2 fw-500">Notifications ({{note.total}})</div>
                    </div>
                    <div v-if="(ajaxcall && note.list.length == 0)" class="d-flex justify-content-center align-items-center notify-loader">
                        <div class="digi-table-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    <div v-else-if="(!ajaxcall && note.list.length == 0)" class="d-flex justify-content-center align-items-center">
                        <h6>No Notifications Found</h6>
                    </div>
                    <div v-else class="scroller" @scroll="infiniteScroll" style="height: 400px !important;overflow: scroll !important;">
                        <el-dropdown-item class="search-custom-note my-1 mx-1" :class="note_in.is_read ? 'selected' : ''" v-for="(note_in, index) in note.list" :key="index">
                            <div class="d-flex justify-content-between align-items-center" style="border-bottom: solid 1px #e4e4e4;" @click="viewNotification(note_in)">
                                <div>
                                    <div style="height: 40px;width: 40px;border-radius: 100%;" v-if="note_in.profile_pic" class="d-flex">
                                        <img :src="note_in.profile_pic"  :alt="note_in.message" class="margin-auto-img" width="40" style="border-radius: 50% !important;">
                                    </div>
                                    <div style="height: 40px;width: 40px;border-radius: 100%;" v-else>
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" :alt="note_in.message" class="margin-auto-img" width="40" style="border-radius: 50% !important;">
                                    </div>
                                </div>
                                <div>
                                    <div class="fs-14 messageText" :title="note_in.message">{{note_in.message}}</div>
                                    <div class="fs-12">{{note_in.created_datetime}}</div>
                                </div>
                            </div>
                        </el-dropdown-item>
                    </div>
                    <el-dropdown-item class="px-0 bg-white">
                        <div v-if="(ajaxcall && note.list.length > 0)" class="d-flex justify-content-center align-items-center notify-loader position-absolute" style="left: 45%;bottom:50px">
                            <half-circle-spinner :animation-duration="1000" :size="35" color="#00448b" style="margin: 0 auto;" />
                        </div>
                        <div class="d-flex justify-content-between px-3 py-1 w-325px w-md-375px" style="border-top:1px solid #afafaf">
                            <div class="lh-30px fs-12 fw-600 text-secondary pointer" @click="gotoNotifications">View All Notifications</div>
                            <div class="lh-30px fs-12 fw-600 pointer text-secondary" v-if="note.list.length" @click="MarkAllAsRead">Mark All Read</div>
                            <div class="lh-30px fs-12 fw-600 text-grey" v-else>Mark All Read</div>
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
    <!-- Notifications Dropdown -->
</template>

<script>
import notification from '../mixins/notification.js';
import { EventBus } from '../eventBus/nav-bar-event.js'
import moment from 'moment-timezone';
export default{
    mixins: [notification],
    data(){
        return {
            load_notification: false,
            note: {
                skip: 0,
                limit: 10,
                search_key: '',
                list: [],
                total: 0,
                count: 0,
                unread_count: 0
            },
            ajaxcall: false,
        }
    },
    methods: {
        async MarkAllAsRead(){
            this.load_notification = true
            await this.markAllAsReadApi({
                is_read_all:true
            })
            EventBus.$emit('updateMarkAllRead');
            this.getNotifications();
            this.load_notification = false
        },
        gotoNotifications(){
            this.$router.push({name: 'NotificationsPage'})
        },
        viewNotification(note){
            this.$router.push({
                path: '/notifications_page',
                query: {
                    id: note.notification_id,
                    is_read: note.is_read
                }
            })
            this.getNotifications()
        },
        async getNotifications(){
            try {
                this.ajaxcall = true
                let params ={
                    skip: this.note.skip,
                    limit: this.note.limit,
                    search_key:this.note.search_key
                }
                let res = await this.getNotificationList(params)
                this.note.list = res.response.notifications
                this.note.list.forEach((x) => {
                    if(x.hasOwnProperty('created_time')){
                        x.created_to_array = x.created_time.split(',')
                        x['time']= x.created_to_array[1].trim()
                        x['date']= x.created_to_array[0]
                        x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | h:mm A")
                    }
                })
                this.note.total = res.response.count
                this.note.count = this.note.list.length
                this.note.unread_count = this.note.total - res.response.read_count
                this.ajaxcall = false
            } catch (reason) {
                console.log(reason)
            }
        },
        async infiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    this.ajaxcall = true
                    let params = {
                        skip: this.note.count,
                        limit: this.note.limit,
                        search_key:this.note.search_key,
                    }
                    let response = await this.getNotificationList(params)
                    if (response.response.skip == this.note.count) {
                        let tempFiles = response.response.notifications
                        tempFiles.forEach(el => {
                            this.note.list.push(el)
                        })
                        this.note.list.forEach((x) => {
                            if(x.hasOwnProperty('created_time')){
                                x.created_to_array = x.created_time.split(',')
                                x['time']= x.created_to_array[1].trim()
                                x['date']= x.created_to_array[0]
                                x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | h:mm A")
                            }
                        })
                        this.note.list = this.note.list.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.note.list.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.note.count += response.response.notifications.length
                        this.ajaxcall = false
                    }
                } catch (reason) {
                    this.ajaxcall = false
                    console.log(reason)
                }
            }
        },
    },
    mounted(){

    },
    computed: {
        
    },
    filters: {
        messageCount: function (value) {
            if (!value) {
                return 0;
            }
            return value > 99 ? '99+' : value;
        }
    },
}
</script>

<style scoped>
.position-relative {
    position: relative !important;
}
.notification-count{
    background-color: rgb(199, 51, 51);
    width: 23px;
    position: absolute;
    border-radius: 100%;
    left: 8px !important;
    bottom: 22px;
    height: 20px;
    font-size: 11px;
    font-weight: 600;
    line-height: 20px;
}
.w-md-375px {
    width: 400px !important;
}
.search-custom-note.el-dropdown-menu__item{
    line-height: 25px !important;
    padding: 2px 10px !important;
    border-radius: 6px !important;
}
.search-custom-note{
    background: #e1e7ee !important;
    /* color: #676767 !important; */
    color: #130e0e !important
}
.search-custom-note.selected{
    background-color: #fff !important
}
.search-custom-note:hover{
    color: #676767 !important;
}

.search-custom-note.selected:hover{
    background-color: transparent !important;
    border-radius: 0px !important;
}
.messageText{
    text-overflow: ellipsis;
    overflow: hidden;
    width: 325px;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: pre-wrap !important;
}
.text-grey{
    color:#e4e4e4 !important;
}
</style>